import React from 'react'
import { Carousel } from 'react-bootstrap'
import { formatearFecha } from '../../helpers/formatearFecha'
import ArrowForwardOutlinedIcon from "@mui/icons-material/ArrowForwardOutlined";


function ArticlesAudit({pendientes}) {

  return (
    <Carousel pause fade id="sliderhome__home" className='heigth-modal'>
              <Carousel.Item
                key={pendientes?.changes?._id}
                className={
                    pendientes?.changes?.align !== ""
                    ? `carousel ${pendientes?.changes?.align}`
                    : "carousel align-center"
                }
                interval={60000}
              >
                <picture>
                  <source
                    media="(orientation: portrait) and (max-width: 1199px)"
                    srcSet={
                      pendientes?.changes?.image_mobile
                        ? pendientes?.changes?.image_mobile[0]?.url
                        : pendientes?.changes?.image_mobile
                    }
                    alt={
                      pendientes?.changes?.image_mobile
                        ? pendientes?.changes?.image_mobile[0]?.alt
                        : pendientes?.changes?.title
                    }
                    title={pendientes?.changes?.title}
                  />
                  <source
                    media="(orientation: landscape) and (max-width: 1199px)"
                    srcSet={
                      pendientes?.changes?.image_tablet
                        ? pendientes?.changes?.image_tablet[0]?.url
                        : pendientes?.changes?.image_tablet
                    }
                    alt={
                      pendientes?.changes?.image_tablet
                        ? pendientes?.changes?.image_tablet[0]?.alt
                        : pendientes?.changes?.title
                    }
                    title={pendientes?.changes?.title}
                  />
                  <img
                    className="img-responsive"
                    src={
                      pendientes?.changes?.image_desktop
                        ? pendientes?.changes?.image_desktop[0]?.url
                        : pendientes?.changes?.image_desktop
                    }
                    alt={
                      pendientes?.changes?.image_desktop
                        ? pendientes?.changes?.image_desktop[0]?.alt
                        : pendientes?.changes?.title
                    }
                    title={pendientes?.changes?.title}
                  />
                </picture>
                <div
                  className={
                    pendientes?.changes?.align === "align-left"
                      ? `container contenedor-left`
                      : pendientes?.changes?.align === "align-right"
                      ? "container contenedor-right"
                      : "container contenedor-center"
                  }
                >
                  <Carousel.Caption>
                    <div className="info-slider-home fadeInRight">
                      <h2 className="stiker-card-slider">{pendientes?.changes?.section}</h2>
                      <h1 className="title-card-slider">{pendientes?.changes?.title}</h1>
                      {pendientes?.changes?.includeDate && (
                        <p className="sliderhome__carousel-fecha">
                          {formatearFecha(pendientes?.changes?.creation_date)}
                        </p>
                      )}
                      <p className="description_desktop content_p">{pendientes?.changes?.content}</p>
                      <p className="description_mobile content_p">{pendientes?.changes?.content_mobile}</p>
                      {pendientes?.changes?.link && (
                        <button className="settings_button-pleno bg-p-primary_2 posicion-boton">
                          <a href={pendientes?.changes?.link} title="ver noticia">
                            <ArrowForwardOutlinedIcon />
                          </a>
                        </button>
                      )}
                    </div>
                  </Carousel.Caption>
                </div>
              </Carousel.Item>
      </Carousel>
  )
}

export default ArticlesAudit